<script>
import appSlicedText from '../app-sliced-text/index.vue'
import appSlicedTextRotator from '../app-sliced-text-rotator/index.vue'
import appHomeSolutionsSelector from '../app-home-solutions-selector/index.vue'
import AppTeamBoardPopin from '../app-team-board-popin/index.vue'
import AppTeamPopin from '../app-team-popin/index.vue'
import appCountUp from '../app-countup/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'
export default {
  name:'app-home-slide',
  props: {
                      debug: {
                          type: Boolean,
                          default: !1
                      },
                     content: {
                         type: Object,
                         default: function() {}
                     },
                     adminContent: {
                         type: Object,
                         default: function() {}
                     },
                     activeIndex: {
                         type: Number,
                         default: 0
                     },
                     indexSS: {
                         type: Number,
                         default: 0
                     },
                     hasVideo: {
                         type: Boolean,
                         default: !1
                     },
                     navOffsetTop: {
                         type: Number,
                         default: 0
                     },
                     headerPageSize: {
                         type: Array,
                         default: function() {}
                     },
                     IsTolltipPopDisabled:{
                       type: Boolean,
                       default: !1
                     }
                 },
                 data: function() {
                     return {
                         isActive: !1,
                         popinContent: null,
                         popinIndex: 0,
                         isPopinActive: !1,
                         isBoardActive: !1,
                         IsActiveCountUp:!1,
                         OfficesVal:0,
                         ClientsVal:0,
                         EmployeesVal:0,
                         SectorsVal:0
                     }
                 },
                 computed:{

                   myStylesTransform2() {
                       return {
                           transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

                       }
                   },
                   myStylesWidthHeight() {
                       return {
                         width: this.headerPageSize[0] + "px",
                         height: this.headerPageSize[1] + "px"

                       }
                   }
                 },
                 components:
                 {
                     appSlicedText,
                     appHomeSolutionsSelector,
                     appSlicedTextRotator,
                     appCountUp,
                     AppTeamPopin,
                    AppTeamBoardPopin,
                     AppScrollObject
                 },
                 watch:
                 {
                     activeIndex: "onActiveIndexChange"
                 },
                 created: function()
                 {
                     this._transitionDuration = 1200,
                     this.eventHub.$on("resize", this.onResize),
                     this.eventHub.$on("close:popin", this.onClosePopin);
                     if(typeof(this.$video)!="undefined")
                     this.$video.play()

                 },
                 destroyed: function ()
                 {
                     this.eventHub.$off("resize", this.onResize),
                     this.eventHub.$off("close:popin", this.onClosePopin)
                 },
                 mounted: function()
                 {
                     this.hasVideo && (this.$video = this.$el.querySelector(".js-video")),
                     0 === this.indexSS ? this.$el.classList.add("is-active") : this.$el.style.visibility = "hidden",
                     this.$imagesContainer = this.$el.querySelectorAll(".js-photo-container")
                 },
                 methods:
                 {
                     onActiveIndexChange: function()
                     {
                       //console.log("Active Index Changed"+this.activeIndex);
                         var t = this;
                         this.activeIndex===3? (this.OfficesVal=15,
                            this.ClientsVal=75,
                            this.EmployeesVal=2000,
                            this.SectorsVal=12,
                            this.IsActiveCountUp=!0):(this.OfficesVal=0,
                               this.ClientsVal=0,
                               this.EmployeesVal=0,
                               this.SectorsVal=0
                               ,this.IsActiveCountUp=!1)
                         this.$el.style.transform = "translateY(" + 100 * -this.activeIndex + "%) translateZ(0)",
                          clearTimeout(this._visibilityTimer),
                          this.indexSS === this.activeIndex
                           ?
                          (this.$el.classList.remove("is-leaving"),
                          setTimeout(function() {   t.$el.classList.add("is-active")   }, 10),
                           this.isActive = !0,
                            this.$el.style.visibility = "visible")
                          :
                          this.isActive
                          &&
                           (this.$el.classList.add("is-leaving"),
                          this.$el.classList.remove("is-active"),
                          this.isActive = !1,
                          this._visibilityTimer = setTimeout(function() {   t.$el.style.visibility = "hidden", t.$el.classList.remove("is-leaving") },
                           this._transitionDuration)),

                          this.indexSS === this.activeIndex && this.hasVideo
                          ?
                           this.playVideo()
                           :
                           this.indexSS !== this.activeIndex && this.hasVideo && this.pauseVideo()
                     },
                     playVideo: function() {
                         var t = this;
                         clearTimeout(e);
                         var e = setTimeout(function() {
                            if(typeof(t.$video)!="unefined")
                             t.$video.play()
                         }, this._transitionDuration)
                     },
                     pauseVideo: function() {
                         this.$video.pause()
                     }
                     ,

                     _onLoadMemberImage: function (t)
                     {
                         this.$imagesContainer[t].classList.remove("is-loading")
                     },
                     onOpenPopin: function (t, e)
                     {

                         var n = this;
                         this.popinIndex = 0,
                         this.popinContent = this.content.subsidiaries_sections[0].subsidiaries[e],
                         this.popinTitle = this.content.subsidiaries_sections[0].title,
                         this.eventHub.$emit("disable:scroll"), this.eventHub.$emit("open:popin"),
                         setTimeout(function ()
                         {
                             n.isPopinActive = !0,
                             n.$el.classList.add("is-popin-active"),
                             n.onTransition()
                         }, 50)
                     },
                     onHoverPopin: function (t, e) {

                         var n = this;

                         var QselectHover = n.$el.querySelector("#hover"+t);
                         var QselectNormal = n.$el.querySelector("#"+t);

                         QselectNormal.classList.remove("fade-enter-active");
                         QselectHover.classList.remove("fade-leave-to");

                         QselectNormal.classList.add("fade-leave-to");
                         QselectHover.classList.add("fade-enter-active");

                     },
                     onHoverOutPopin: function (t, e)
                     {
                    
                         var n = this;
                         var QselectHover = n.$el.querySelector("#hover"+t);
                         var QselectNormal = n.$el.querySelector("#"+t);
                         QselectNormal.classList.remove("fade-leave-to");
                         QselectHover.classList.remove("fade-enter-active");

                         QselectNormal.classList.add("fade-enter-active");
                         QselectHover.classList.add("fade-leave-to");
                     },
                     onClosePopin: function ()
                     {
                         this.eventHub.$emit("enable:scroll"),
                         this.isPopinActive = !1,
                         this.isBoardActive = !1,
                         this.$el.classList.remove("is-popin-active"),
                         this.onTransition()

                     },
                     onOpenBoard: function(t)
                     {
                         var e = this;
                         t === this.content.subsidiaries_sections.length - 1 && (this.eventHub.$emit("disable:scroll"), this.eventHub.$emit("open:popin"),
                         setTimeout(function () {
                             e.isBoardActive = !0,
                             e.onTransition()
                         }, 50))
                     },
                     onTransition: function ()
                     {
                         var t = this;
                         this.$el.classList.add("is-switching"),
                         clearTimeout(this._timerTransition),
                         this._timerTransition = setTimeout(function () {
                             t.$el.classList.remove("is-switching")
                         }, 650)
                     }



                 }
}
</script>



// WEBPACK FOOTER //
// src/components/app-home-slide/index.vue